var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAirplane = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6.5764c0 3.2867-15.845 6.9147-17.0447 6.9147-.6727 0-1.436-.1551-1.436-.7752 0-.2072.2392-.5067.6589-.8677l-.0005.0002L.5655 9.8722a.508.508 0 0 1 .2538-.7206l.1911-.0766a1.27 1.27 0 0 1 1.0662.0566l2.0191 1.0689c.7862-.4663 1.678-.9545 2.618-1.4352L2.7788 6.2124c-.3113-.2019-.308-.6587.0063-.8561l.3218-.2023a2.286 2.286 0 0 1 1.7988-.2746l6.5459 1.7266c2.0411-.81 3.8864-1.363 4.9787-1.363.2917 0 .5838.0078.8657.028l-1.9768.8923-.0473.665 3.0515-1.4028c.7315.1744 1.1766.5 1.1766 1.1508M11.5365 12.25l2.4417 2.7737a.508.508 0 0 0 .5954.125l.3269-.152a1.524 1.524 0 0 0 .8712-1.5587l-.3056-2.6137a.254.254 0 0 0-.3367-.21l-3.4867 1.2283c-.1697.0598-.2251.2723-.1062.4074"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAirplane);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/airplane.ecaade82919185177ce58fb0122d3fc0.svg";